import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            探索苍井空的世界
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
            从人生轨迹到艺术创作，多个维度深入了解她的故事
          </p>
          <div className="mt-4 w-12 h-0.5 bg-primary-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-500 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {category.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {category.description}
                </p>
                <p className="mt-2 text-xs text-foreground-400">
                  {category.articleCount} 篇文章
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}